import { render, staticRenderFns } from "./popover-item.vue?vue&type=template&id=5b3d7caa&"
import script from "./popover-item.vue?vue&type=script&lang=js&"
export * from "./popover-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/popover/popover-item.vue
// module id = 961
// module chunks = 0